export const getTotalChallenges = challenges => {
  let total = 0;
  if (challenges != null) {
    for (const challenge of challenges) {
      if (challenge.started != null || challenge.end_date != null) {
        total = total + 1;
      }
    }
  }
  return total;
};



// WEBPACK FOOTER //
// ./src/functions/getTotalChallenges.tsx